<template>
  <div class="ds-custom-query-item">
    <div class="ds-cutome-query-item-nothover">
      <span class="ds-custom-query-item-field">{{data.field||"无字段"}}</span>
      <el-select size="small" class="ds-custom-query-item-datatype" v-model="data.dataType" v-if="$queryTree.showDataType">
        <el-option label="字符串" value="string"></el-option>
        <el-option label="日期" value="date"></el-option>
        <el-option label="数字" value="number"></el-option>
      </el-select>
      <el-select size="small" class="ds-custom-query-item-op" v-model="data.operator">
        <el-option label="等于" value="eq"></el-option>
        <el-option label="不等于" value="noteq"></el-option>
        <el-option label="包含" value="in"></el-option>
        <el-option label="不包含" value="notin"></el-option>
        <el-option label="大于" value="gt"></el-option>
        <el-option label="小于" value="lt"></el-option>
        <el-option label="大于等于" value="gteq"></el-option>
        <el-option label="小于等于" value="lteq"></el-option>
        <el-option label="匹配" value="like"></el-option>
        <el-option label="开头匹配" value="slike"></el-option>
        <el-option label="结尾匹配" value="elike"></el-option>
        <el-option label="区间" value="between"></el-option>
        <el-option label="介于" value="gtlt"></el-option>
      </el-select>
      <div class="ds-custom-query-item-value">
        <el-input v-model="data.value" size="small" />
      </div>

    </div>
    <div class="ds-cutome-query-item-hovering">
      <div class="ds-custom-query-pos-top" @mouseover="mouseOverHandler($event,'before')"></div>
      <div class="ds-custom-query-pos-bottom" @mouseover="mouseOverHandler($event,'after')"></div>
    </div>
    <div class="ds-custom-query-item-close" @click="remove()">
      <DsfIcon name="icon_close" title="删除"></DsfIcon>
    </div>
  </div>
</template>
<script>
export default {
  name: "DsfCustomQueryItem",
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  inject: {
    $queryLogic: {
      default: null
    },
    $queryTree: {
      default: null
    },
    $queryNode: {
      default: null
    }
  },
  data() {
    return {
      hover: false,
      pos: ""
    };
  },
  computed: {},
  beforeCreate() {},
  created() {
    if (this.data && this.$queryTree) {
      this.$queryTree.setNode(this.data);
    }
    if (!this.data.operator) {
      this.$set(this.data, "operator", "eq");
    }
  },
  beforeMount() {},
  mounted() {
    this.initDrag();
    this.initDrop();
  },
  beforeDestroy() {},
  destroyed() {},
  methods: {
    initDrag() {
      let _this = this;
      // let box = $(_this.$queryLogic.getContainer());
      if (this.$el && this.$el.nodeType == 1) {
        $(this.$el).draggable({
          helper: "clone",
          cursor: "move",
          scroll: true,
          refreshPositions: true,
          appendTo:_this.$queryTree.dragProxyAppendTo,
          distance: 5,
          delay: 100,
          // containment:".ds-custom-query",
          cursorAt: {
            left: -5,
            top: -5
          },
          revert: "invalid",
          drag(event, ui) {
            _this.$queryLogic.dragAutoScroll({
              top: event.clientY,
              left: event.clientX
            });
          },
          stop() {
            _this.$queryTree.dragStart = false;
          },
          start() {
            _this.$queryTree.dragStart = true;
          }
        });
      }
    },
    initDrop() {
      let _this = this;
      if (this.$el && this.$el.nodeType == 1) {
        $(this.$el).droppable({
          accept: function () {
            return true;
          },
          greedy: true,
          tolerance: "pointer",
          hoverClass: "ds-cutsom-query-drop-hover",
          drop($evt, ui) {
            if (_this.pos) {
              let fromComponent = ui.draggable.get(0).__vue__;
              let fromData;
              //组件内部节点互相拖动
              if (_this.$queryTree.dragStart) {
                fromData = fromComponent.data;
              }
              //与外部节点拖动
              else {
                fromData = _this.$queryTree.createItemData(fromComponent.data);
              }
              _this.dropToItem(fromData, _this.data, _this.pos);
              _this.$queryTree.dropEnd();
              _this.pos = "";
            }
          }
        });
      }
    },
    remove() {
      this.$queryTree.removeNode(this.data);
    },
    mouseOverHandler($evt, pos) {
      this.pos = pos;
      // console.log(this.pos)
    },
    dropToItem(fromNode, targetNode, pos) {
      this.removeNodeFromNode(fromNode);
      this.insertNode(fromNode, targetNode, pos);
      this.$queryTree.resetTree();
    },
    removeNodeFromNode(node) {
      let items = node?.parent?.items;
      if (items) {
        dsf.array.remove(items, node);
      }
    },
    insertNode(fromNode, targetNode, pos) {
      let obj = {
        logic: "and",
        items: []
      };
      if (pos == "after") {
        obj.items.push(targetNode);
        obj.items.push(fromNode);
      } else {
        obj.items.push(fromNode);
        obj.items.push(targetNode);
      }
      let items = targetNode?.parent?.items;
      if (items) {
        let index = _.findIndex(items, (it) => it == targetNode);
        if (items.length == 1) {
          obj.logic = targetNode.parent.logic;
        }
        if (index >= 0) {
          items.splice(index, 1, obj);
        }
      }
    }
  }
};
</script>